<template>
	<div class="bf plr20">
		<div class="pt20">
			<div class="page_title mb10">积分明细</div>
		</div>
		<div class="pt20 pb20 bor_b" :key="index" v-for="(item,index) in list">
			<div class="flex flex_between flex_items mb10">
				<div>{{item.title}}</div>
				<div :class="item.amount >= 0 ? 'main_color' : 'red'">{{item.amount >= 0 ? ('+'+item.amount) : item.amount}}</div>
			</div>
			<div class="flex flex_between flex_items ca6">
				<div>{{item.created_at}}</div>
				<div>剩余：{{item.balance}}</div>
			</div>
		</div>
		<div class="empty" v-if="list.length == 0">
			暂无数据
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				id: 0,
			}
		},
		methods: {
			getList() {
				this.api.scoreLogs().then(res => {
					this.list = res.data;
				})
			}
		},
		created() {
			this.getList()
		}
	}
</script>

<style>
</style>
